module.exports={
    record: {
        search:'Search',
        sure:'OK',
        expList:"Export",
        expHint:{
            errorMsg:"Record export failed, please try again！",
            successMsg:"Record exported successfully",
        },
        table:{
        	index:'Number',
        	mac:'ESL MAC address',
        	commodity:'ID',
        	updateTime:'Update time',
        	type:'Operation type',
        	result:'Operation result',
        	operator:'Operator',
            // updateLabel:'更新标签',           //数据库字段，不可改
            // updateLabel1:'Update ESL',
            // upgradeESL:'升级标签',            //数据库字段，不可改
            // upgradeESL1:'Upgrade ESL',
            // updateSucceeded:'更新成功',       //数据库字段，不可改
            // updateSucceeded1:'Update succeeded',
            // updateFailed:'更新失败',          //数据库字段，不可改
            // updateFailed1:'Update failed',
            // upgradeESLSucceeded:'升级成功',   //数据库字段，不可改
            // upgradeESLSucceeded1:'Upgrade succeeded',
            // upgradeESLFailed:'升级失败',      //数据库字段，不可改
            // upgradeESLFailed1:'Upgrade failed'
        },
        hintMsg:{
            queryRecordFail:'Query logging failed'
        },
        // operation:[{
        //     name:'Update ESL',
        //     value:'更新标签'
        // },{
        //     name:'Update succeeded',
        //     value:'更新成功'
        // },{
        //     name:'Update failed',
        //     value:'更新失败'
        // }],


        operationType:[{    //操作类型
            value:'',
            label:'All operation types'
        },{
            value:'1',
            label:'Update ESL'
        },{
            value:'2',
            label:'Upgrade ESL'
        }],
        operationResult:[{   //操作结果
            result:[{
                value:'',
                label:'All operation results'
            }]
        },{
            result:[{
                value:'1',
                label:'Update succeeded'
            },{
                value:'2',
                label:'Update failed'
            },{
                value:'3',
                label:'Label key error'
            },{
                value:'7',
                label:'Update timeout'
            },{
                value:'9',
                label:'Screen damage'
            },{
                value:'10',
                label:'Gateway offline'
            },{
                value:'11',
                label:'Template error or inexistence'
            },{
                value:'12',
                label:'Gateway hardware exception'
            },{
                value:'13',
                label:'Inconsistent firmware and template'
            }]
        },
        {
            result:[{
                value:'3',
                label:'Label key error'
            },{
                value:'4',
                label:'Upgrade succeeded'
            },{
                value:'5',
                label:'Upgrade failed'
            },{
                value:'6',
                label:'Upgrade package error'
            },{
                value:'8',
                label:'Upgrade timeout'
            },{
                value:'10',
                label:'Gateway offline'
            },{
                value:'12',
                label:'Gateway hardware exception'
            }]
        }],
        typeAndResult:[{  //操作类型和操作结果映射关系,按顺序获取
            key:'',
            value:0
        },{
            key:'1',
            value:1
        },{
            key:'2',
            value:2
        }],
        type:{
            // resultAll:'全部操作结果'
            // operationTypeMsg:'请选择操作类型',
            // operationResultMsg:'请选择操作结果'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/record.js